import { render, staticRenderFns } from "./RectangularSankey.vue?vue&type=template&id=02f96307&scoped=true&"
import script from "./RectangularSankey.vue?vue&type=script&lang=js&"
export * from "./RectangularSankey.vue?vue&type=script&lang=js&"
import style0 from "./RectangularSankey.vue?vue&type=style&index=0&id=02f96307&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f96307",
  null
  
)

export default component.exports